import { supabase } from '../lib/supabase';
import { analyticsService } from './analyticsService';

export const shareService = {
  /**
   * Logs a sharing action privately and triggers public analytics tracking.
   */
  logShare: async (cardId, userId, slug, shareType, platform = null) => {
    try {
      // Log to private history
      await supabase.from('card_shares').insert({
        card_id: cardId,
        user_id: userId,
        share_type: shareType,
        platform: platform
      });

      // Track public analytics event
      await analyticsService.trackEvent(slug, 'share_initiated', 'direct', {
        share_type: shareType,
        platform: platform
      });
    } catch (err) {
      console.error('Failed to log share action:', err);
    }
  },

  /**
   * Fetches the recent sharing history for a specific card.
   */
  getHistory: async (cardId, userId) => {
    const { data, error } = await supabase
      .from('card_shares')
      .select('*')
      .eq('card_id', cardId)
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .limit(50);
      
    if (error) throw error;
    return data || [];
  },

  /**
   * Fetches aggregated sharing stats for the dashboard.
   */
  getDashboardStats: async (userId) => {
    const { data, error } = await supabase
      .from('card_shares')
      .select('share_type')
      .eq('user_id', userId);
      
    if (error) throw error;
    
    const stats = {
      total: data.length,
      links: 0,
      qrs: 0,
      social: 0
    };
    
    data.forEach(s => {
      if (s.share_type === 'link_copied') stats.links++;
      else if (s.share_type.startsWith('qr_')) stats.qrs++;
      else if (s.share_type.startsWith('social_')) stats.social++;
    });
    
    return stats;
  }
};